<template>
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
  
      <v-data-table
        :headers="headers"
        :items="records"
        item-key="subject_id"
        :search="search"
        :expanded.sync="expanded"
        :single-expand="false"
        show-expand
        :options="{ itemsPerPage: 50 }"
        dense
      >
        <!-- Expanded Slot -->
        <template v-slot:expanded-item="{ item }">
          <td :colspan="headers.length">
            <br>
            <span
                v-for="classItem in item.class"
                :key="classItem.class_id"
              >
                  {{ classItem.class }},
          </span>
          <br><br>
          </td>
        </template>
  
        <!-- Actions Slot -->
        <template v-slot:item.actions="{ item }">
          <v-btn @click="editRecord(item)" fab light x-small class="mr-2">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            v-if="item.has_results === 0"
            @click="deleteRecord(item)"
            fab
            color="error"
            x-small
          >
            <v-icon small>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    name: "ViewSubjectsTableList",
    props: ["authToken", "school", "records"],
    data: () => ({
      editFormSignal: false,
      search: "",
      expanded: [],
      headers: [
        { value: "subject", text: "Subject Name" },
        { text: "", value: "data-table-expand" },
        { value: "actions", text: "Actions", sortable: false },
      ],
    }),
    methods: {
      editRecord(record) {
        this.$emit("editFormSignal", record); // Emit the event with data or response
      },
  
      deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/subjects/'+record.subject_id+'?school_id='+this.school.school_id+'&confirm=DELETE',{
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    }); 
                    this.$emit("refreshSignal", "yes"); // Emit the event with data or response 
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        }
    },
  };
  </script>
  